import { ApiError } from './http-client';

export interface QueryViewSource {
  readonly isLoading: boolean;
  readonly isError: boolean;
  readonly data: unknown;
  readonly error?: unknown;
  readonly isFetching?: boolean;
  refetch: () => unknown;
}

export interface QueryStateSignals {
  readonly isLoading: boolean;
  readonly isError: boolean;
  readonly hasData: boolean;
  readonly error: unknown;
  readonly isRetrying: boolean;
  onRetry: () => void;
}

export function queryView(q: QueryViewSource): QueryStateSignals {
  return {
    get isLoading() {
      return q.isLoading;
    },
    get isError() {
      return q.isError;
    },
    get hasData() {
      return q.data !== undefined;
    },
    get error() {
      return q.isError ? q.error : undefined;
    },
    get isRetrying() {
      return q.isError && q.isFetching === true;
    },
    onRetry: () => {
      void q.refetch();
    },
  };
}

export function combineQueryViews(views: readonly QueryStateSignals[]): QueryStateSignals {
  return {
    get isLoading() {
      return views.some((v) => v.isLoading);
    },
    get isError() {
      return views.some((v) => v.isError);
    },
    get hasData() {
      return views.every((v) => v.hasData);
    },
    get error() {
      return views.find((v) => v.isError)?.error;
    },
    get isRetrying() {
      return views.some((v) => v.isRetrying);
    },
    onRetry: () => {
      const failed = views.filter((v) => v.isError);
      for (const v of failed.length > 0 ? failed : views) v.onRetry();
    },
  };
}

export interface QuerySettledSource {
  readonly isSuccess: boolean;
  readonly isError: boolean;
  readonly isFetching: boolean;
  readonly isPlaceholderData: boolean;
}

export function queryIsSettled(q: QuerySettledSource): boolean {
  return q.isSuccess && !q.isFetching && !q.isPlaceholderData && !q.isError;
}

export type ErrorView = 'card' | 'stale' | null;

export function errorViewOf(isError: boolean, hasData: boolean): ErrorView {
  if (!isError) return null;
  return hasData ? 'stale' : 'card';
}

export function loadErrorHint(error: unknown): string {
  return error instanceof ApiError && error.status > 0
    ? error.message
    : 'Нет связи с сервером — проверьте подключение.';
}
